import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import { ConnectedRouter } from "connected-react-router";
import { ThemeProvider as StyledThemeProvider } from "styled-components";

import App from "./App";
import { GlobalStyles } from "./globalStyles";
import configureStore, { history } from "./configureStore";

const theme = {
  palette: {
    primary: {
      "100": "#e8f0fc",
      "200": "#A8BDD9",
      "300": "#889CB8",
      "400": "#697D97",
      "500": "#4b5f78",
      "600": "#3F5269",
      "700": "#34455B",
      "800": "#2A374C",
      "900": "#1F2A3D",
      "150": "#1ABC9C"
    },
    secondary: {
      main: "#ffa500"
    },
    grey: {
      "100": "#eef2f4",
      "300": "#c6cfd4"
    },
    green: "#2DBC9C"
  },
  typography: {
    fontFamily: '"Montserrat", sans-serif',
    overline: {
      fontSize: "1rem"
    }
  }
};

const MUITheme = createMuiTheme(theme);

const store = configureStore();

export default function Root() {
  return (
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <StyledThemeProvider theme={theme}>
          <ThemeProvider theme={MUITheme}>
            <GlobalStyles />
            <App />
          </ThemeProvider>
        </StyledThemeProvider>
      </ConnectedRouter>
    </Provider>
  );
}
